module.exports = __webpack_public_path__ + "static/media/fly0071.2b331ee7.webp";